import { http } from '@/helpers/easyindustriaapi/config';

export default class CallController {
    constructor(user, empresa) {
        this.currentUser = user;
        this.currentEmpresa = empresa;
    }

    async store(call) {
        const resolvedEmpresaId = this.currentEmpresa?.id || call?.empresa_id;
        const payload = {
            ...call,
            empresa_id: resolvedEmpresaId,
        };
        return await http.post('/calls', payload);
    }
}

